import { AgencyCreateDrawer } from '@/modules/agencies/components/AgencyCreateDrawer'
import { AgencyEmptyState } from '@/modules/agencies/components/AgencyEmptyState'
import {
  AgencyListError,
  AgencyListLoading,
} from '@/modules/agencies/components/AgencyListState'
import { AgencyTable } from '@/modules/agencies/components/AgencyTable'
import { AgencyToolbar } from '@/modules/agencies/components/AgencyToolbar'
import { useAgenciesPage } from '@/modules/agencies/hooks/useAgenciesPage'

export function AgenciesPage() {
  const {
    agencies,
    isLoading,
    isError,
    errorMessage,
    isEmpty,
    openCreate,
    onSelectAgency,
  } = useAgenciesPage()

  return (
    <section className="flex flex-col gap-6">
      <AgencyToolbar agencyCount={agencies.length} onCreateAgency={openCreate} />

      {isLoading ? <AgencyListLoading label="Loading agencies…" /> : null}
      {isError && errorMessage ? (
        <AgencyListError title="Could not load agencies" message={errorMessage} />
      ) : null}
      {!isLoading && !isError && isEmpty ? <AgencyEmptyState /> : null}
      {!isLoading && !isError && !isEmpty ? (
        <AgencyTable agencies={agencies} onSelectAgency={onSelectAgency} />
      ) : null}

      <AgencyCreateDrawer />
    </section>
  )
}
